// extracted by mini-css-extract-plugin
module.exports = {"slider":"KToB9","disabled":"rx1o4","panel":"GUDP2"};